class BD_Timer {
  bbId = null;
  question = null; // bd-question object
  timer = null;
  timerPopupTitle = "";
  timerPopupMessage = "";
  goToNext = false;
  stopped = false;

  constructor(bbData, question) {
    if (!bbData.timer) return;

    $("#timer").hide();
    this.bbId = bbData.id;
    this.timer = parseInt(bbData.timer);
    this.timerPopupMessage = bbData.timer_popup_message;
    this.timerPopupTitle = bbData.timer_popup_title;
    this.goToNext = CFG.game_options.go_to_next_when_time_runs_out;
    this.addEvents();
    this.question = question;
  }

  start() {
    $("#timer").show();
    const remainingTimeFromStorage = bdStorage.state.timerRemaining[this.bbId] || 0;
    this.enableSubmitButtonHandler();
    this.tick(remainingTimeFromStorage || this.timer);
  }

  enableSubmitButtonHandler() {
    if (!CFG.game_options.enable_submit_button_after_time_runs_out) {
      this.enableSubmitButton();
    }
  }

  tick(timerInSeconds) {
    timerInSeconds = timerInSeconds - 1;

    const timerStr = new Date(timerInSeconds * 1000).toISOString().substr(11, 8);
    $("#timerTimer").text(timerStr);

    if (this.stopped) return;
    if (timerInSeconds <= 0) return this.runout();

    setTimeout(() => {
      var timerRemaining = { ...bdStorage.state.timerRemaining };
      timerRemaining[this.bbId] = timerInSeconds;
      bdStorage.save("timerRemaining", timerRemaining);

      this.tick(timerInSeconds);
    }, 1000);
  }

  stop() {
    this.stopped = true;
  }

  // this method always called, even when building block have no timer.
  // if building block have no timer, this method will be called immediately
  runout() {
    this.stopped = true;
    this.enableSubmitButton();
    this.showPopup();
    this.goToNextSequence();
  }

  enableSubmitButton() {
    $(".js-submit").removeAttr("disabled");
    $(".js-submit").removeClass("wait-for-timeout");
  }

  showPopup() {
    if (!this.timerPopupMessage && !this.timerPopupTitle) return;

    $("#timedOut-popup").addClass("is-opened");

    if (this.timerPopupTitle) {
      $("#timedOut-popup .popup-title").html(this.timerPopupTitle);
    }

    if (this.timerPopupMessage) {
      $("#timedOut-popup .popup-body").html(this.timerPopupMessage);
    }
  }

  goToNextSequence() {
    if (!this.goToNext) return;

    this.question.submitAnswerRequest(-1);
  }

  addEvents() {
    $("#timedOut-popup .popupClose-btn").click(() => {
      $("#timedOut-popup").removeClass("is-opened");
      $(".wait-for-timeout").removeAttr("disabled");
      $(".wait-for-timeout").removeClass("wait-for-timeout");
    });
  }
}
